import React from "react";
import { Div } from "components/Base";
import CollapsablePanel from "Portal/NewPortal/Shared/CollapsablePanel";
import { Label } from "EventLight/Common/FieldLayout";
import {
  Input,
  AdvancedWYSIWYG,
  Dropdown,
  PhoneInput,
  File,
  TextAreaInput,
  CheckboxInput,
  DateTimeInput
} from "ui-kit/Form/View";
import { setLocalZone } from "utils/General";

import useDisplay from "Portal/NewPortal/Shared/useDisplay";
import { useMobile } from "Portal/NewPortal/Shared/UseMobile";
import { getFieldValueToShow } from "../../selectors";

export const resolveField = ({
  eventTimezone,
  field,
  data,
  disabled,
  updatedFieldValues
}) => {
  /**
   * Todo:
   * Date
   * Date Time
   * Time
   * Clean up file field
   * Countries
   * Currency
   * Percent
   * Signature
   */

  if (field.type === "datetime") {
    return (
      <DateTimeInput
        fieldId={field.id}
        iniValue={setLocalZone(
          getFieldValueToShow({
            data,
            updatedData: updatedFieldValues,
            fieldId: field.id
          }),
          eventTimezone
        )}
        materialUI
        modalVariant
        disabled={disabled}
      />
    );
  }

  if (field.type === "signature") {
    return (
      <>
        {data[field.id] && data[field.id].length ? (
          <img
            src={data[field.id]}
            style={{
              maxWidth: "190px",
              maxHeight: "auto"
            }}
          />
        ) : (
          "-"
        )}
      </>
    );
  }

  if (field.type === "checkbox") {
    return (
      <CheckboxInput
        fieldId={field.id}
        disabled={disabled}
        iniValue={getFieldValueToShow({
          data,
          updatedData: updatedFieldValues,
          fieldId: field.id
        })}
      />
    );
  }

  if (field.type === "wysiwyg") {
    return (
      <AdvancedWYSIWYG
        fieldId={field.id}
        disabled={disabled}
        iniValue={getFieldValueToShow({
          data,
          updatedData: updatedFieldValues,
          fieldId: field.id,
          defaultValue: ""
        })}
        placeholder={""}
        height={200}
      />
    );
  }

  if (field.type === "textarea") {
    return (
      <TextAreaInput
        fieldId={field.id}
        width={1}
        disabled={disabled}
        iniValue={getFieldValueToShow({
          data,
          updatedData: updatedFieldValues,
          fieldId: field.id
        })}
        size="big"
        inputType="outline"
      />
    );
  }

  if (field.type === "phone") {
    return (
      <PhoneInput
        fieldId={field.id}
        disabled={disabled}
        iniValue={getFieldValueToShow({
          data,
          updatedData: updatedFieldValues,
          fieldId: field.id,
          defaultValue: "+1"
        })}
        size="big"
        style={{ width: "100%", height: "40px" }}
        type="tel"
        inputType="outline"
      />
    );
  }

  if (field.type === "file") {
    return (
      <File
        fieldId={field.id}
        disabled={disabled}
        iniValue={getFieldValueToShow({
          data,
          updatedData: updatedFieldValues,
          fieldId: field.id
        })}
        options={{}}
        width="100%"
      />
    );
  }

  if (field.type === "dropdown") {
    return (
      <Dropdown
        fieldId={field.id}
        disabled={disabled}
        iniValue={getFieldValueToShow({
          data,
          updatedData: updatedFieldValues,
          fieldId: field.id
        })}
        multipleSelect={field.settings.allowMultipleSelect ? true : false}
        menuHeight={150}
        width="100%"
        usePortal
        options={
          field.settings.options
            ? field.settings.options.map(o => ({
                label: o.value,
                id: o.id
              }))
            : []
        }
      />
    );
  }

  return (
    <Input
      fieldId={field.id}
      disabled={disabled}
      iniValue={getFieldValueToShow({
        data,
        updatedData: updatedFieldValues,
        fieldId: field.id
      })}
      size="big"
      type={
        field.type === "email"
          ? "email"
          : field.type === "number"
          ? "number"
          : "text"
      }
      inputType="outline"
    />
  );
};

const EventInfo = ({
  data = {},
  updatedFieldValues = {},
  fields,
  eventInfoTitle,
  lockedFieldIds
}) => {
  const display = useDisplay();
  const isMobile = useMobile();
  return (
    <Div display="column" width={isMobile ? 1 : 0.7}>
      <CollapsablePanel title={eventInfoTitle}>
        <Div display="column" p={5} style={{ gap: 16 }} width={1}>
          {fields.map(pairedFields => {
            return (
              <Div
                display={display}
                width={1}
                style={{
                  gap: 20
                }}
              >
                {pairedFields.map(field => {
                  return (
                    <Div display="column" width={1}>
                      <Label fs={2} color="neutral7">
                        {field.name}
                      </Label>
                      {resolveField({
                        field,
                        data,
                        updatedFieldValues,
                        disabled: lockedFieldIds.includes(field.id)
                      })}
                    </Div>
                  );
                })}
              </Div>
            );
          })}
        </Div>
      </CollapsablePanel>
    </Div>
  );
};

export default EventInfo;
